<template>
  <!-- 设备信息 -->
  <!-- FIXME: 在electron版本无法显示 -->
  <div id='bd-device'>
    <!-- TODO: 增加显示设备信息：web/ios/android设备信息 -->
    <div style="font-size: 15px;">
      <li v-for="finger in fingerPrints" :key="finger.key">
        <p>{{ $t(finger.key) }} : <el-link>{{ finger.value}}</el-link></p>
      </li>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-device',
  data () {
    return {
      // 用户信息
      tags: [], //
      //
      inputVisible: false,
      inputValue: ''
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentMonitorThread', 'fingerPrints', 'userCurrentCustomer' ]),
    nameTip () {
      return this.$t('name')
    },
    mobileTip () {
      return this.$t('mobile')
    },
    emailTip () {
      return this.$t('email')
    },
    companyTip () {
      return this.$t('company')
    },
    noteTip () {
      return this.$t('note')
    },
    tagTip () {
      return this.$t('tag')
    }
  },
  methods: {
    ...mapActions([ 'fingerPrint', 'userTag' ]),
    showEditCrmDrawer () {
      // console.log('showEditCrmDrawer')
      bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER)
    },
    handleTagDelete (tagid) {
      console.log('handleTagDelete:', tagid)
      //
    },
    showTagInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      console.log('handleInputConfirm:', this.inputValue)
      let tagName = this.inputValue
      if (tagName) {
        //
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleCommand (command) {
      this.$message('click on item ' + command)
    }
  }
}
</script>

<style scoped>
#bd-device {
  height: 100%;
  width: 100%;
  text-align: left;
}
li {
  list-style: none;
}
.bd-device-table {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  overflow-y: scroll !important;
}
.bd-user-tags {
  margin-top: 20px;
  margin-right: 5px;
}
.bd-input-new-tag{
  width:78px;
  margin-top: 20px;
  margin-left: 5px;
  vertical-align:bottom;
}
.bd-new-tag {
  margin-top: 20px;
  margin-left:10px;
}
</style>
